import { useCallback, useContext, useRef } from 'react'

import { faFlower, faLeaf, faSnowflake, faSun } from '@fortawesome/pro-regular-svg-icons'
import { Box, Typography } from '@material-ui/core'
import { SelectableIconChips } from '@scoir/college-search'

import CharacterLimitInput from '../../../CharacterLimitInput'
import ContentModalContext from '../../ContentModalProvider/Context'
import ValidationMessage from '../../components/ValidationMessage'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../components/constants'

const Season = () => {
  const { item, onUpdateField, validation } = useContext(ContentModalContext)
  const touchedSeasonRef = useRef(false)
  const touchedSeason = touchedSeasonRef.current

  const onSelect = useCallback(
    (value) => {
      touchedSeasonRef.current = true
      let newSeasonArr = [...(item[FIELD_NAMES.SEASON] ?? [])]
      if (!newSeasonArr.includes(value)) {
        newSeasonArr.push(value)
      } else {
        newSeasonArr = newSeasonArr.filter((season: string) => season !== value)
      }

      if (touchedSeason && !newSeasonArr.length) {
        validation.setError(LABELS.SEASON, ERROR_MESSAGES.REQUIRED)
      }
      onUpdateField(FIELD_NAMES.SEASON, newSeasonArr)
    },
    [item, onUpdateField, touchedSeason, validation],
  )

  return (
    <>
      <Typography variant="subtitle2">{`${LABELS.SEASON}*`}</Typography>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={2}
        mb={3}
      >
        <SelectableIconChips
          gridItemProps={{ xs: 3 }}
          onSelect={onSelect}
          options={[
            {
              title: LABELS.WINTER,
              faIcon: faSnowflake,
              value: LABELS.WINTER,
              selected: item[FIELD_NAMES.SEASON]?.includes(LABELS.WINTER),
            },
            {
              title: LABELS.SPRING,
              faIcon: faFlower,
              value: LABELS.SPRING,
              selected: item[FIELD_NAMES.SEASON]?.includes(LABELS.SPRING),
            },
            {
              title: LABELS.SUMMER,
              faIcon: faSun,
              value: LABELS.SUMMER,
              selected: item[FIELD_NAMES.SEASON]?.includes(LABELS.SUMMER),
            },
            {
              title: LABELS.FALL,
              faIcon: faLeaf,
              value: LABELS.FALL,
              selected: item[FIELD_NAMES.SEASON]?.includes(LABELS.FALL),
            },
          ]}
        />
        <ValidationMessage
          label={LABELS.SEASON}
          touched={touchedSeason}
          valuesByError={{
            [ERROR_MESSAGES.REQUIRED]: item[FIELD_NAMES.SEASON],
          }}
        />
      </Box>
      <CharacterLimitInput
        id={FIELD_NAMES.SEASON_DESCRIPTION}
        value={item[FIELD_NAMES.SEASON_DESCRIPTION]}
        field={FIELD_NAMES.SEASON_DESCRIPTION}
        label={LABELS.SEASON_DESCRIPTION}
        placeholder={LABELS.SEASON_DESCRIPTION}
        onUpdateField={onUpdateField}
        validation={validation}
      />
    </>
  )
}

export default Season
